export default __webpack_public_path__ + "static/media/nav-back.7ca7ee5e.svg";